import { startRegistration, startAuthentication, browserSupportsWebAuthn } from '@simplewebauthn/browser';

export { browserSupportsWebAuthn };

export function passkeyWasCancelled(error) {
  return error?.name === 'NotAllowedError'
    || error?.code === 'ERROR_CEREMONY_ABORTED'
    || error?.cause?.name === 'NotAllowedError';
}

export function passkeyErrorMessage(error, fallback) {
  if (passkeyWasCancelled(error)) return '';
  if (error?.code === 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED') {
    return 'This passkey is already saved on your account.';
  }
  if (error?.response?.status === 429) {
    return 'Too many attempts. Wait a few minutes and try again.';
  }
  return error?.response?.data?.message || error?.message || fallback;
}

export function registerPasskey(optionsJSON) {
  return startRegistration({ optionsJSON });
}

export function authenticatePasskey(optionsJSON) {
  return startAuthentication({ optionsJSON });
}
